import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui';

export const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen bg-secondary-50 flex flex-col items-center justify-center px-4">
      <div className="text-center">
        {/* 404 Illustration */}
        <div className="mb-8">
          <svg
            className="mx-auto h-40 w-40 text-primary-200"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
          </svg>
        </div>

        {/* Error code */}
        <h1 className="text-9xl font-bold text-primary-600">404</h1>

        {/* Message */}
        <h2 className="mt-4 text-3xl font-bold text-secondary-900 sm:text-4xl">
          Page not found
        </h2>
        <p className="mt-4 text-lg text-secondary-600 max-w-md mx-auto">
          Sorry, we could not find the page you are looking for. It might have been
          moved or deleted.
        </p>

        {/* Actions */}
        <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/dashboard">
            <Button variant="primary">
              <svg
                className="w-5 h-5 mr-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                />
              </svg>
              Go to Dashboard
            </Button>
          </Link>
          <Button variant="outline" onClick={() => window.history.back()}>
            <svg
              className="w-5 h-5 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
            Go Back
          </Button>
        </div>

        {/* Help links */}
        <div className="mt-12">
          <p className="text-sm text-secondary-500">
            Need help?{' '}
            <a
              href="/support"
              className="font-medium text-primary-600 hover:text-primary-500"
            >
              Contact support
            </a>{' '}
            or{' '}
            <a
              href="/docs"
              className="font-medium text-primary-600 hover:text-primary-500"
            >
              view documentation
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
